<span class="icon">
  <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
    <use attr.xlink:href="#{{icon}}"></use>
  </svg>
</span>